// Check if we're in an iframe (like VS Code Simple Browser)
try {
  // Only set document.domain if we're not in an iframe
  if (!window.frameElement) {
    document.domain = window.location.hostname;
  }
} catch (e) {
  // Silently ignore if setting document.domain is not allowed (sandboxed iframe)
  console.debug('Cannot set document.domain in sandboxed iframe');
}

const devConfig = {
  BASE_URL: `http://${window.location.host}`,
  SOCKET_BASE_URL: process.env.REACT_APP_SOCKET_BASE_URL || `ws://${window.location.hostname}:8000`,
  API_BASE_URL: process.env.REACT_APP_API_BASE_URL || `http://${window.location.hostname}:8000/api/`,
  JITSI_RELEASE: process.env.REACT_APP_JITSI_RELEASE || undefined,
  GOOGLE_OAUTH_CLIENT_ID: '728115001508-1rvai2rv337eo4jat13gk0io3g0imi2a.apps.googleusercontent.com',
  MIXPANEL_TOKEN: 'd6ab5dd3cabeff906f074e0597893d7d',
  GTM_ID: 'G-WQX60MGBVK',
  FIREBASE_CONFIG: {
    apiKey: 'AIzaSyCgKzZBNg5yjfA5VB2w3WK901gUPeS27Go',
    authDomain: 'stayq-fb-dev.firebaseapp.com',
    databaseURL: 'https://stayq-fb-dev-default-rtdb.firebaseio.com',
    projectId: 'stayq-fb-dev',
    storageBucket: 'stayq-fb-dev.appspot.com',
    messagingSenderId: '1026580340703',
    appId: '1:1026580340703:web:0682ae7b0245c004256e6a',
    measurementId: 'G-L7GFM0HFY5',
  },
  RECORDING_WEBHOOK_URL: 'https://cloud.activepieces.com/api/v1/webhooks/v1lAf86aV0ccXy5ZYTvw5',
  ADOBE_PDF_EMBED_KEY: '6c942f34b0fd4b8d9c9e3b93cfd12f16',
};

export default devConfig;
